
import { useState, useEffect } from "react";

export const useWorksheetPagination = (totalCount: number, itemsPerPage: number = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  
  // Calculate total pages
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  
  // Reset to first page when totalCount changes
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(1);
    }
  }, [totalCount, totalPages, currentPage]);

  // Calculate range for pagination
  const getPaginationRange = () => {
    const from = (currentPage - 1) * itemsPerPage;
    const to = from + itemsPerPage - 1;
    return { from, to };
  };

  return {
    currentPage,
    setCurrentPage,
    totalPages,
    getPaginationRange
  };
};
